import { createRouter, createWebHistory } from 'vue-router'
import { isWeChatBrowser } from '../utils/wechat'
import { isLocalDevHost, isReviewPreviewPath } from '../utils/devMode'
import {
  resolveTargetPath,
  shouldSkipEntryResolve,
  isEntryLandingPath,
  isBrowseMode
} from '../utils/reviewRedirect'

const routes = [
  {
    path: '/open-in-wechat',
    name: 'OpenInWeChat',
    component: () => import('../views/OpenInWeChat.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/task/:id',
    name: 'TaskDetail',
    component: () => import('../views/TaskDetail.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/AdminLogin.vue')
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import('../views/AdminDashboard.vue')
  },
  {
    path: '/admin/review/:id',
    name: 'ReviewDetail',
    component: () => import('../views/ReviewDetail.vue')
  },
  {
    path: '/poster',
    name: 'Poster',
    component: () => import('../views/Poster.vue')
  },
  {
    path: '/review-pending/:id?',
    name: 'ReviewPending',
    component: () => import('../views/ReviewPending.vue')
  },
  {
    path: '/review-success/:id?',
    name: 'ReviewSuccess',
    component: () => import('../views/ReviewSuccess.vue')
  },
  {
    path: '/review-rejected/:id?',
    name: 'ReviewRejected',
    component: () => import('../views/ReviewRejected.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.path.startsWith('/admin')) {
    if (to.path !== '/admin/login') {
      const token = localStorage.getItem('adminToken')
      if (!token) {
        next('/admin/login')
        return
      }
    }
    next()
    return
  }

  if (to.path === '/open-in-wechat') {
    next()
    return
  }

  if (!isLocalDevHost() && !isWeChatBrowser()) {
    next('/open-in-wechat')
    return
  }

  if (isLocalDevHost() && isReviewPreviewPath(to.path)) {
    next()
    return
  }

  if (!shouldSkipEntryResolve(to.path)) {
    if (isBrowseMode() && isEntryLandingPath(to.path)) {
      next()
      return
    }

    const target = await resolveTargetPath(to.fullPath)

    if (target && isEntryLandingPath(to.path) && to.path !== target) {
      window.location.replace(target)
      return
    }

    if (target && to.path.startsWith('/review-') && to.path !== target) {
      window.location.replace(target)
      return
    }
  }

  next()
})

export default router
